'use strict';

import {settingsData} from "../../../settings";
import { CustomerContactNow } from './CustomerContactNow';
import {IconTextLong} from "../../interfaces/buttons/apple/IconTextLong";
import {Button} from "../../interfaces/buttons/Button";
import { contactsData } from './contactUsConfig';
import {changeLangToCurrent, getCurrentLang} from '../../components/langSwitcher/langSwitcher';
import {
  changeFormTitle,
  changePlaceholder,
  customiseForm,
  moveFormToBlock,
  setTranslateToSendBtn,
} from '../../components/form/form';
import {BaseElement} from "../../interfaces/BaseElement";
import { GoogleMaps } from '../../api/GoogleMaps';
import {getUrlParam} from "../../../functions";
import { BmbyMode } from '../../mode/BmbyMode';

let data = null;

export async function getContactsDataFromAPI() {
  if (BmbyMode.active) {
    data = [];
    return data;
  }
  if (!data)
    data = await contactsData();

  return data;
}

export const createContactUs = async (parent) => {
  const contactUsBlock = new BaseElement()
    .addClass('contact-us__content','background-backdrop-filter')
    .appendTo(parent)
    .DOMElement;

  if (CustomerContactNow.isActive) {
    contactUsBlock.classList.add('customer-contact-now');
    moveFormToBlock(contactUsBlock, 'afterbegin');
    return;
  }

  const previewContactUs = new BaseElement()
    .addClass('contact-us__preview')
    .appendTo(contactUsBlock)
    .DOMElement;
  const previewBar = new BaseElement()
    .addClass('contact-us__preview-bar')
    .appendTo(previewContactUs)
    .DOMElement;
  const previewBarInfo = new BaseElement()
    .addClass('contact-us__preview-info')
    .appendTo(previewBar)
    .DOMElement;
  const previewBarTitle = new BaseElement('span')
    .addClass('contact-us__preview-title', 'text', 'subheadline')
    .appendTo(previewBarInfo)
    .DOMElement;
  const previewBarAddress = new BaseElement('span')
    .addClass('contact-us__preview-address', 'text', 'footnote')
    .appendTo(previewBarInfo)
    .DOMElement;

  createNavigateButton(previewBar);

  const contactsContactUs = new BaseElement()
    .addClass('contact-us__contacts')
    .appendTo(contactUsBlock)
    .DOMElement;
  const buttonsContactUs = new BaseElement()
    .addClass('contact-us__buttons')
    .appendTo(contactUsBlock)
    .DOMElement;

  await getContactsDataFromAPI().then(() => {
    addTitle(previewBarTitle);
    addText(previewBarAddress);
    addMap(previewContactUs);
    addContacts(contactsContactUs);
    addButtons(buttonsContactUs);
  });

  new CustomerContactNow('contact-us')
    .appendTo(buttonsContactUs);

  checkAndRemoveEmptyWrappers([buttonsContactUs]);

  if (config.general.leadForm || settingsData.isConferenceHost) {
    customiseForm(document.querySelector('.form__container-main'));
    const form = document.querySelector('.form__container-main');
    moveFormToBlock(contactsContactUs, 'afterend');
    changeFormTitle('leadFormTitle');
    setTranslateToSendBtn(form);
    changePlaceholder(form);
  }
}

function checkAndRemoveEmptyWrappers(wrappers = []) {
  wrappers.forEach(wrapper => {
    if (wrapper.children.length === 0)
      wrapper.remove();
  });
}

const navigateToHandler = () => {
  const long = data.find(item => item.title === 'map')?.crmData.longitude;
  const lat = data.find(item => item.title === 'map')?.crmData.latitude;
  window.open(`https://maps.google.com/?saddr=My+Location&daddr=${lat},${long}`, '_blank');
}

const addTitle = (parent) => {
  const title = data.find(item => item.title === 'title')?.crmData;
  if (title) {
    if (title[getCurrentLang()]) {
      parent.innerText = title[getCurrentLang()];
    } else {
      parent.innerText = title['en'];
    }
  }
}

const addText = (parent) => {
  const text = data.find(item => item.title === 'text')?.crmData;
  if (text) {
    if (text[getCurrentLang()]) {
      parent.innerText = text[getCurrentLang()];
    } else {
      parent.innerText = text['en'];
    }
  }
}

const addMap = (parent) => {
  const mapContainer = new BaseElement()
    .addClass('contact-us__map')
    .appendTo(parent)
    .DOMElement;

  const coordinates = data.find(item => item.title === 'map')?.crmData;
  if (coordinates) {
    new GoogleMaps().then(() => {
      const map = new google.maps.Map(mapContainer, {
        zoom: 15,
        center: {lat: Number(coordinates.latitude), lng: Number(coordinates.longitude)},
      });
      // The marker, positioned at Uluru
      new google.maps.Marker({
        position: {lat: Number(coordinates.latitude), lng: Number(coordinates.longitude)},
        map: map,
      });
    });
  }
}

const addButtons = (parent) => {
  const phone = data.find(item => item.title === 'phones')?.crmData;
  if (phone && !(config.general.leadForm || settingsData.isConferenceHost)) {
    new IconTextLong('Call')
      .addIconClass('icon-call')
      .addClass('contact-us__action-button')
      .event('click', callHandler.bind(this, phone))
      .appendTo(parent);
  }

  const chatUrl = data.find(item => item.title === 'chatUrl')?.crmData;
  if (chatUrl) {
    const buttonChat = new BaseElement('button')
      .addClass('contact-us__buttons-btn', 'button')
      .appendTo(parent)
      .DOMElement;

    new BaseElement('span')
      .addClass('icon-chat')
      .appendTo(buttonChat);

    new BaseElement('span')
      .addClass('contact-us__buttons-chat', 'language-string')
      .addAttribute('data-dictionary', 'Chat with manager')
      .innerHtml(changeLangToCurrent('Chat with manager'))
      .event('click', () => window.open(chatUrl) )
      .appendTo(buttonChat);
  }
}

const callHandler = (phone) => {
  window.location.href = 'tel:' + phone;
}

const addContacts = (parent) => {
  const contactsList = new BaseElement('ul')
    .addClass('contacts-list', 'background-backdrop-filter')
    .appendTo(parent)
    .DOMElement;

  const contactsArray = ['phones', 'website', 'emails', 'phone', 'email'];
  data.forEach(item => {
    const object = contactsArray.find(elem => elem === item.title);
    if (!object)
      return;

    const element = new BaseElement('li')
      .addClass('contacts-list__item',
            'mobile-menu-item',
            'contacts-us__item',
            'horizontal-separator'
      ).appendTo(contactsList);

    const link = new BaseElement('a')
      .addClass('contacts-list__link', 'text', 'body')
      .appendTo(element.DOMElement);
    const text = new BaseElement('span')
      .addClass('text');
    switch (item.title) {
      case 'website':
        link
          .addAttribute('target', '_blank')
          .addAttribute('href', item.crmData);

        const websiteDescriptionData = config.features?.contactUs?.website;
        if (websiteDescriptionData) {
          const innerText = changeLangToCurrent(websiteDescriptionData[getCurrentLang()]) || websiteDescriptionData['en'];
          link
            .addClass('language-string')
            .innerHtml(innerText)

          for (const key in websiteDescriptionData) {
            link.addAttribute(`data-lang-${key}`, websiteDescriptionData[key])
          }
        } else {
          link.innerHtml(item.crmData);
        }

        break;
      case 'phones':
        link
          .innerHtml(item.crmData)
          .addAttribute('href', `tel:${item.crmData}`)
        break;
      case 'emails':
        link
          .innerHtml(item.crmData)
          .addAttribute('href', `mailto:${item.crmData}`)
        break;
      case 'phone':
        link
          .innerHtml(item.crmData.value)
          .addAttribute('href', `tel:${item.crmData.value}`);
        const phoneInnerText = item.crmData.title[getCurrentLang()] || item.crmData.title['en'];
        text
            .innerHtml(phoneInnerText)
            .addClass('language-string');
        for (const language in item.crmData.title) {
          text.addAttribute(`data-lang-${language}`, item.crmData.title[language]);
        }
        element.prependElement(text.DOMElement)
        break;
      case 'email':
        const emailInnerText = item.crmData.title[getCurrentLang()] || item.crmData.title['en'];
        link
          .innerHtml(item.crmData.value)
          .addAttribute('href', `mailto:${item.crmData.value}`);
        text.innerHtml(emailInnerText);
        element.prependElement(text.DOMElement)
        break;
      default:
        break;
    }

    if (item.icon) {
      new BaseElement('span')
        .addClass('contacts-list__icon', `${item.icon}`)
        .appendTo(element.DOMElement)
    }
  });
}

export function contactUsChangeLanguage () {
  const contactUs = document.querySelector('.contact-us__content');
  if (!contactUs) return;
  const title = contactUs.querySelector('.contact-us__preview-title');
  const address = contactUs.querySelector('.contact-us__preview-address');
  if (title && address) {
    title.innerHTML = '';
    address.innerHTML = '';
    addTitle(title);
    addText(address);
  }

  const map = contactUs.querySelector('.contact-us__map');
  if (map) {
    map.remove();
    new GoogleMaps().then(() => addMap(document.querySelector('.contact-us__preview')));
  }
}

export function createNavigateButton (parent) {
  const isIOSApp = getUrlParam('ios') && parseInt(getUrlParam('ios')) === 1;
  return new Button('Navigate')
      .addClass('contact-us__preview-navigate', 'button', 'cards-buttons', 'icon-ios-navigate'/*'pill-button', */, isIOSApp ? 'hidden' : undefined)
      .event('click', navigateToHandler)
      .appendTo(parent);
}
